// extracted by mini-css-extract-plugin
export var cover = "CaseIndexItem-module--cover--d106e";
export var item = "CaseIndexItem-module--item--67e1e";
export var itemBg = "CaseIndexItem-module--itemBg--6a21b";
export var text = "CaseIndexItem-module--text--901b3";
export var textBg = "CaseIndexItem-module--textBg--9c636";
export var title = "CaseIndexItem-module--title--c43d8";